import { render, staticRenderFns } from "./temporary-expenditure.vue?vue&type=template&id=ac937e20&"
import script from "./temporary-expenditure.vue?vue&type=script&lang=js&"
export * from "./temporary-expenditure.vue?vue&type=script&lang=js&"
import style0 from "./temporary-expenditure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports